import { executePost } from "../ServiceMethods";
import { removeUserCredentials, userId } from "../LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../ErrorMessages";

const uid = userId();

export const CouponsApi = async (cb) => {
  const data = {
    user_id: 18,
  };

  try {
    const couponsData = await executePost("/myCoupons", data);
    const CouponsData = couponsData.data ? couponsData.data : [];
    return CouponsData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
